export const IS_APLICATIVO_INGRESO_DISABLED = "FALSE";
export const LENGTH_DESCRIPTION_CUT = 2;